import React, { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton } from "../../components/btn/Buttons";
import Dropdown from "../../components/inputs/Dropdown";
import SmallModal from "../../components/modal/SmallModal";
import { Alerts } from "../../components/Alerts/Alerts";
import { useSelector } from "react-redux";
import store from "../../redux/store";
import { get_profitability_analysis_report_list } from "./finacialReportSlice";
import { get_stock_report_list } from "../transactionReport/transactionReportSlice";
import NoData from "../../components/NoData";
import { Pagination3 } from "../../components/pagination/pagination";
import Table from "../../components/table/Table";
import Loader from "../../components/Loader";
import PageLoading from "../../components/PageLoading";

const ProfitabilityAnalysis = () => {
  // States to store the selected year and month
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonth1, setSelectedMonth1] = useState("");
  const [godown_id, setGodown_id] = useState("");
  const [alerts, setAlerts] = useState(false);
  const [alertsMess, setAlertsMess] = useState("");
  const [showData, setShowData] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { stock_report_list } = useSelector((state) => state.transactionReport);

  const {
    profitability_analysis_report,
    profitability_analysis_loading,
    profitability_analysis_totalCount,
  } = useSelector((state) => state.finacialReport);
  console.log("profitability_analysis_report", profitability_analysis_report);

  // Handlers for when the year or month changes
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    setSelectedMonth1("");
  };

  const valiDate = () => {
    const data = [];
    if (selectedMonth === "" || selectedMonth === "SELECT") {
      data.push("Please select the corresponding month");
    }
    if (selectedYear === "" || selectedYear === "SELECT") {
      data.push("Please select the corresponding year");
    }
    return data;
  };

  const handleSave = () => {
    const data = valiDate();
    store.dispatch(
      get_profitability_analysis_report_list({
        page: page,
        limit: limit,
        year: selectedYear,
        month: selectedMonth,
        month1: selectedMonth1,
        godown_id: godown_id,
      })
    );
    setShowData(true);
    // if (data?.length > 0) {
    //   setAlerts(true);
    //   setAlertsMess(<Alerts data={data} />);
    // }
  };
  useEffect(() => {
    store.dispatch(get_stock_report_list());
  }, []);
  const TableHeaderProduct = {
    AGENCY_NAME: "AGENCY NAME",
    PRODUCT_CATEGORY: "PRODUCT CATEGORY",
    PRODUCT_NAME: "PRODUCT NAME",
    // TOTAL_STOCK: "TOTAL STOCK",
    TOTAL_PURCHASE_VALUE: "PURCHASE VALUE",
    TOTAL_PURCHASE_RETURN_VALUE: "PURCHASE RETURN VALUE",
    TOTAL_SALES_VALUE: "SALES VALUE",
    CLOSING_STOCK_VALUE: "CLOSING STOCK VALUE",
    // CLOSING_STOCK_EMPTIES: "CLOSING STOCK EMPTIES",
    // CLOSING_STOCK: "CLOSING STOCK",
    GROSS_PROFIT: "GROSS PROFIT",
  };

  const financialMonths = [
    { value: 4, label: "APR" },
    { value: 5, label: "MAY" },
    { value: 6, label: "JUN" },
    { value: 7, label: "JUL" },
    { value: 8, label: "AUG" },
    { value: 9, label: "SEP" },
    { value: 10, label: "OCT" },
    { value: 11, label: "NOV" },
    { value: 12, label: "DEC" },
    { value: 1, label: "JAN" },
    { value: 2, label: "FEB" },
    { value: 3, label: "MAR" },
  ];
  const getFYIndex = (month) =>
    financialMonths.findIndex((m) => m.value === Number(month));

  return (
    <div className="container">
      <PageHeading title={"PROFITABILITY ANALYSIS"} right={<BackButton />} />
      <div style={{ height: "20px" }}></div>

      <div className="df mt10 gap10 " style={{ marginBottom: "20px" }}>
        <div style={{ width: "120px" }}>
          <Dropdown
            label={"YEAR"}
            value={selectedYear}
            onChange={handleYearChange}
            options={
              <>
                <option value="">SELECT</option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </>
            }
          />
        </div>
        <div style={{ width: "120px" }}>
          <Dropdown
            disabled={!selectedYear}
            label="FROM MONTH"
            value={selectedMonth}
            onChange={handleMonthChange}
            options={
              <>
                <option value="">SELECT</option>
                {financialMonths.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </>
            }
          />
        </div>
        <div style={{ width: "120px" }}>
          <Dropdown
            disabled={!selectedMonth}
            label="TO MONTH"
            value={selectedMonth1}
            onChange={(e) => setSelectedMonth1(e.target.value)}
            options={
              <>
                <option value="">SELECT</option>

                {financialMonths.map((m) => (
                  <option
                    key={m.value}
                    value={m.value}
                    disabled={
                      selectedMonth &&
                      getFYIndex(m.value) < getFYIndex(selectedMonth)
                    }
                  >
                    {m.label}
                  </option>
                ))}
              </>
            }
          />
        </div>
        <div style={{ width: "230px" }}>
          <Dropdown
            label="PRODUCT CATEGORY (Optional)"
            value={godown_id}
            onChange={(e) => {
              setGodown_id(e.target.value);
            }}
            options={
              <>
                <option value="">SELECT</option>
                <option value="1">DOMESTIC</option>
                <option value="2">COMMERCIAL</option>
                <option value="3">REGULATOR</option>
                <option value="4">ARB</option>
              </>
            }
          />
          {/* <Dropdown
            label="SELECT GODOWN"
            value={godown_id}
            onChange={(e) => {
              setGodown_id(e.target.value);
            }}
            options={
              <>
                <option value="">SELECT</option>
                {stock_report_list?.godownlist
                  ?.filter(
                    (obj, index, self) =>
                      index === self.findIndex((t) => t?.ID === obj?.ID)
                  )
                  ?.map((v, i) => (
                    <option value={v?.ID} key={i}>
                      {v?.UNIT_NAME}
                    </option>
                  ))}
              </>
            }
          /> */}
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <button
            className="GENERATE-BTN"
            onClick={() => {
              handleSave();
            }}
          >
            FETCH
          </button>
        </div>
      </div>
      {showData &&
        (profitability_analysis_loading ? (
          <PageLoading />
        ) : (
          <Pagination3
            count={0}
            search={false}
            download={false}
            top={true}
            totalCount={profitability_analysis_totalCount}
            pageNo={page}
            setPageNo={setPage}
            entries={limit}
            setEntries={setLimit}
          >
            <Table
              headData={Object.values(TableHeaderProduct)}
              nodata={profitability_analysis_report?.length == 0}
              body={profitability_analysis_report?.map((v, i) => (
                <tr key={i}>
                  {Object.keys(TableHeaderProduct).map((key) => (
                    <td key={key}>{v?.[key]}</td>
                  ))}
                </tr>
              ))}
            />
          </Pagination3>
        ))}
      {/* --- Data Result Section --- */}
    </div>
  );
};

export default ProfitabilityAnalysis;
